import React from 'react'
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

const PhoneSuccess = () => {
  const history = useHistory();
  return (
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className='flex flex-column align-items-center'>
          <h3>Two-step Verification</h3>
          <span>Two-step verification adds an additional layer of security by using a second device to verify your identity.</span>
          <Divider className='py-3' />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <div style={{ width: '150px', height: '150px'}} className="bg-green-500 border-circle flex justify-content-center align-items-center mx-auto">
            <i className="pi pi-check text-white" style={{ 'fontSize': '3em' }}></i>
          </div>
          <h2 className='text-center'>Success!</h2>
          <p className='mt-5'>{history.location.state.mobilePhone} has been verified and can receive <br />
            verification codes.</p>
          <Button onClick={() => history.push("/auth/multi-factor-auth")} label="Close" className="mt-5 p-button-outlined p-button-info w-full py-3" />
        </div>
      </div>
    </div>
  )
}

export default PhoneSuccess